// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"caf15352","277":"e790b6aa","352":"96edbd94","453":"fc7fe99f","528":"0960f332","604":"a117509a","615":"ab47185e","617":"445b98e1","679":"7575fe3e","685":"da5db505","744":"3d7e58db","747":"daf66c08","767":"40e088b9","914":"235cc46d"}[chunkId] + ".chunk.js";
};